import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function Changepassword() {
    const [formData, setFormData] = useState({
        current_password: '',
        new_password: '',
        confirm_password: '',
        username: ''
    });

    const [showPassword, setShowPassword] = useState({
        current_password: false,
        new_password: false,
        confirm_password: false
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const id = localStorage.getItem('user_id');
    const username = localStorage.getItem('username');
    formData.username = username;

    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const togglePasswordVisibility = (field) => {
        setShowPassword((prevState) => ({
            ...prevState,
            [field]: !prevState[field]
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        if (formData.new_password !== formData.confirm_password) {
            toastr.error('New password and confirm password do not match.');
            setLoading(false);
            return;
        }

        try {
            const response = await axios.put(`https://api.eazyworldehsengineering.com/api/auth/changepassword/${id}`, formData);
            localStorage.clear();
            toastr.success("Password Updated Successfully");
            navigate('/login');
            setFormData({ current_password: '', new_password: '', confirm_password: '', username: '' });
        } catch (error) {
            const errMsg = error.response?.data?.error || 'An error occurred. Please try again.';
            setError(errMsg);
            toastr.error(errMsg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Change Password</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Change Password</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container d-flex justify-content-center">
                <div className="col-md-6">
                    <div className="card shadow-lg border-0">
                        <div className="card-header bg-primary text-white">
                            <h4 className="mb-0"><i className="fas fa-key me-2"></i>Update Password</h4>
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                {['current_password', 'new_password', 'confirm_password'].map((field, idx) => (
                                    <div className="mb-3" key={idx}>
                                        <label className="form-label text-capitalize">{field.replace(/_/g, ' ')}</label>
                                        <div className="input-group">
                                            <input
                                                type={showPassword[field] ? 'text' : 'password'}
                                                name={field}
                                                value={formData[field]}
                                                onChange={handleChange}
                                                className="form-control"
                                                placeholder={`Enter ${field.replace(/_/g, ' ')}`}
                                                required
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary"
                                                onClick={() => togglePasswordVisibility(field)}
                                            >
                                                <i className={`fas ${showPassword[field] ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                            </button>
                                        </div>
                                    </div>
                                ))}

                                {error && (
                                    <div className="alert alert-danger mt-3" role="alert">
                                        {error}
                                    </div>
                                )}

                                <button
                                    type="submit"
                                    className="btn btn-success w-100"
                                    disabled={loading}
                                >
                                    {loading ? 'Updating...' : 'Update Password'}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Changepassword;
